module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/achelos-iot/modals/delete-question-modal/delete-question-modal.component.css
// module id = ./src/app/achelos-iot/modals/delete-question-modal/delete-question-modal.component.css
// module chunks = main